import { useTranslations } from '@ms/yammer-i18n-react';
import SkiplinkStrings from '@ms/yammer-strings/dist/Skiplink';
import Block from '@ms/yammer-web-core-ui/dist/components/Block';
import ExternalLink from '@ms/yammer-web-core-ui/dist/components/ExternalLink';
import React, { FC } from 'react';

import FocusMainContentButton from '../FocusMainContentButton';
import ShowWhenContainsFocus from '../ShowWhenContainsFocus';

/**
 * Skiplink and accessibility messages.
 *
 * Skiplinks are links to main content that appear at top of the page and allow
 * user to skip over navigation directly to the main part of the page; invisible
 * until they receive focus, so available to mouse and keyboard users, but
 * hidden to mouse-only users.
 */
const Skiplink: FC = () => {
  const t = useTranslations(SkiplinkStrings);
  const screenreaderHelpUrl = 'https://go.microsoft.com/fwlink/?linkid=2073771';

  return (
    <ShowWhenContainsFocus>
      <Block bottomSpacing={1}>
        <ExternalLink href={screenreaderHelpUrl}>{t.skiplinkTips()}</ExternalLink>
      </Block>
      <FocusMainContentButton text={t.skiplinkSkipTo()} />
    </ShowWhenContainsFocus>
  );
};

export default Skiplink;
